import { getCampaignStatusBadgeClass } from '../../utils/statusColors';

interface CampaignStatusBadgeProps {
  status: string;
}

export function CampaignStatusBadge({ status }: CampaignStatusBadgeProps) {
  return (
    <span className={`cm-chip ${getCampaignStatusBadgeClass(status, 'soft')}`}>
      {status}
    </span>
  );
}
